// extracted by mini-css-extract-plugin
export default {"skip_main_content":"SideBarLayout_skip_main_content__7mcRN","main":"SideBarLayout_main__+2TPe","main_row":"SideBarLayout_main_row__qzYaU"};